const LeadCountsForListing = ({
  countsIncomplete = false,
  listingAlias = '',
  notRepliedToCount = 0,
  totalConversationsCount = 0,
  unreadCount = 0,
} = {}) => ({
  countsIncomplete: Boolean(countsIncomplete),
  listingAlias: String(listingAlias),
  notRepliedToCount: Number(notRepliedToCount),
  totalConversationsCount: Number(totalConversationsCount),
  unreadCount: Number(unreadCount),
});

export default LeadCountsForListing;

export type LeadCountsForListingProps = ReturnType<typeof LeadCountsForListing>;
